import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Card, Popconfirm, Input, TreeSelect, Modal, Button, ColorPicker, Col, Row, message, Space, Popover, Tag, Form, Select } from "antd";
const AdminFolderModal = ({
    setEditCard = () => { },
    setOpen = () => { },
    get_data = () => { },
    edit = false,
    editcard = {},
    title = '',
    open = false,
    color = 'd65b77',
    tag = true,
    classify_structure_type_id = 0,
}) => {
    const [tag_data, set_tag_data] = useState([]);
    const [folder_data, set_folder_data] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [nodeName, setNodeName] = useState("");
    // useEffect(() => {
    //     console.log(editcard)
    // }, [editcard])
    useEffect(() => {
        get_tag();
    }, [])
    const get_tag = () => {
        axios
            .get('/component/classify/media/hashtag')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((item, i) => {
                    let data_json = {};
                    data_json['label'] = item.tag_name;
                    data_json['value'] = item.tag_id;
                    data_tmp.push(data_json);
                })
                set_tag_data(data_tmp)
            })
    }
    const handleSubmit = () => {
        // console.log({ ...editcard, classify_structure_type_id: classify_structure_type_id })
        if (editcard.name == '' || editcard.name == undefined) {
            messageApi.open({
                type: 'error',
                content: '請填寫必填欄位',
            });
        } else {
            axios
                .post('/cramSchool/api/media/classify_structure_type_folder', { ...editcard, classify_structure_type_id: classify_structure_type_id, classify_structure_id: 1 })
                .then((response) => {
                    setOpen(false);
                    if (response.data.status == 'failure') {
                        messageApi.open({
                            type: 'error',
                            content: '新增失敗',
                        });
                        get_data();

                    } else {
                        messageApi.open({
                            type: 'success',
                            content: '新增成功',
                        });
                        get_data();

                    }
                })
        }
    }
    const handleUpdate = () => {
        // console.log(classify_structure_type_id)
        axios
            .patch('/cramSchool/api/media/classify_structure_type_folder', [editcard])
            .then((response) => {
                setOpen(false);
                if (response.data.status == 'failure') {
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    get_data();

                } else {
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    get_data();

                }
            })
    }
    const handleDelete = (key) => {
        const deleterow = [{ "classify_structure_type_id": key }];
        axios
            .patch('/media/api/classify_structure_type_folder_delete', deleterow)
            .then((response) => {
                setOpen(false);
                if (response.data.status == 'failure') {
                    messageApi.open({
                        type: 'error',
                        content: '刪除失敗',
                    });
                    get_data();

                } else {
                    messageApi.open({
                        type: 'success',
                        content: '刪除成功',
                    });
                    get_data();

                }
            })
    }
    useEffect(() => {
        // console.log(classify_structure_type_id)
        axios
            .get('/component/classify/type/folder', { params: { classify_structure_id: 1, classify_structure_type_id: 0 } })
            .then((response) => {
                set_folder_data(response.data.data)
                // const callback = (item, i) => {
                //     let data_json_tmp = {};
                //     data_json_tmp['value'] = item['classify_structure_type_id']
                //     data_json_tmp['title'] = item['name'];
                //     return data_json_tmp;
                //     // data_tmp.push(data_json_tmp);
                // }
                // response.data.data.map((value, index) => {
                //     let data_json_tmp_out = {};
                //     let data_tmp = [];
                //     value.children.map((item, i) => {
                //         let data_json_tmp = {};
                //         data_json_tmp['value'] = item['classify_structure_type_id']
                //         data_json_tmp['title'] = item['name'];
                //         data_tmp.push(data_json_tmp);

                //     })
                //     data_json_tmp_out['title'] = value['name'];
                //     data_json_tmp_out['value'] = value['classify_structure_type_id'];
                //     data_json_tmp_out['children'] = data_tmp;
                //     // console.log(data_json_tmp_out);
                //     // console.log(data_tmp);
                //     set_folder_data((pre) => {
                //         return (
                //             [
                //                 ...pre,
                //                 data_json_tmp_out
                //             ]
                //         )
                //     })
                // })
            })
    }, [classify_structure_type_id])
    // useEffect(() => {
    //     console.log(folder_data)
    // }, [folder_data])
    return (
        <>
            {contextHolder}
            <Modal
                style={{ pointerEvents: 'auto' }}
                open={open}
                bodyStyle={{ backgroundColor: edit ? '#faf6f5' : '#FCF5F6' }}
                width={450}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid ${color} 5px `, position: 'relative', height: '80vh' }}>
                        <Row gutter={[10, 10]} justify='center' style={{ minHeight: '65vh', maxHeight: '65vh', overflowY: 'scroll' }}>
                            <Col span={24} >
                                <Row gutter={[8, 16]} align={'middle'}>
                                    <Col span={24}>
                                        <Row justify="space-between" style={{ position: 'relative' }} align={'bottom'}>
                                            {edit ?
                                                <>
                                                    <img width="35%" height="35%" src='/cram_school/edit.png'></img>
                                                </> :
                                                <>
                                                    <img width="35%" height="35%" src='/cram_school/add.png'></img>
                                                </>}
                                            <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 35, left: 45 }} >{title}</Col>
                                            <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 65, left: 35 }} >資料夾</Col>
                                            <Col>
                                                {edit ?
                                                    <>
                                                        <Popconfirm
                                                            placement="topRight"
                                                            title='確定刪除嗎？'
                                                            onConfirm={e => handleDelete(editcard['classify_structure_type_id'])}
                                                            okText="確定"
                                                            cancelText="取消"
                                                        >
                                                            <Button style={{ backgroundColor: '#FCF5F6' }} >
                                                                <Row>
                                                                    <Col span={6}>
                                                                        <img width="80%" src='/cram_school/trashicon.png'></img>
                                                                    </Col>
                                                                    <Col span={18}>
                                                                        <span>刪除資料夾</span>
                                                                    </Col>
                                                                </Row>
                                                            </Button>
                                                        </Popconfirm>
                                                    </> :
                                                    <>
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row gutter={[8, 8]} align={'middle'}>
                                            <Col span={7}>資料夾名稱</Col>
                                            <Col span={17}>
                                                <Input onChange={e => setEditCard(pre => {
                                                    return ({
                                                        ...pre,
                                                        name: e.target.value,
                                                    })
                                                })}
                                                    value={editcard.name}
                                                    placeholder="請填資料夾名稱（必填）"></Input>
                                            </Col>
                                            <Col span={7}>資料夾顏色</Col>
                                            <Col span={17}>
                                                <ColorPicker
                                                    format={'hex'}
                                                    value={editcard.background_color}
                                                    onChange={color =>
                                                        setEditCard((pre) => {
                                                            return (
                                                                {
                                                                    ...pre,
                                                                    background_color: `#${color.metaColor.toHex()}`,
                                                                }
                                                            )
                                                        })
                                                    }></ColorPicker>
                                            </Col>
                                            <Col span={7}>文字顏色</Col>
                                            <Col span={17}>
                                                <ColorPicker
                                                    format={'hex'}
                                                    value={editcard.font_color}
                                                    onChange={color =>
                                                        setEditCard((pre) => {
                                                            return (
                                                                {
                                                                    ...pre,
                                                                    font_color: `#${color.metaColor.toHex()}`,
                                                                }
                                                            )
                                                        })
                                                    }></ColorPicker>
                                            </Col>
                                            {tag != false ? <>  <Col span={7}>hashtag</Col>
                                                <Col span={17}>
                                                    <Select
                                                        mode="multiple"
                                                        allowClear
                                                        style={{
                                                            width: 250,
                                                        }}
                                                        labelInValue
                                                        placeholder="請選擇hashtag"
                                                        value={(editcard?.['tag_name'] || []).length != 0 ? editcard['tag_id'].map((value) => value) : []}
                                                        onChange={value => {
                                                            setEditCard((pre) => {
                                                                return (
                                                                    {
                                                                        ...pre,
                                                                        tag_id: value.map((tmp) => tmp.value),
                                                                        tag_name: value.map((tmp) => tmp.label),
                                                                    }
                                                                )
                                                            })
                                                        }
                                                        }
                                                        options={tag_data}
                                                    />
                                                </Col>
                                            </> : null}
                                            {edit ? <>
                                                <Col span={8}>將資料夾移至</Col>
                                                <Col span={16}>
                                                    <TreeSelect
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                        allowClear
                                                        treeDefaultExpandAll
                                                        // value={form_data['learn_english_year_id'] || value.placeholder}
                                                        onChange={(newValue) => setEditCard(pre => {
                                                            return ({
                                                                ...pre,
                                                                'classify_structure_type_parent_id': newValue,
                                                                // 'learn_english_year_name': value.label,
                                                            })
                                                        })}
                                                        treeData={folder_data}
                                                    />
                                                </Col>
                                            </> : null}
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => setOpen(false)} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button
                                            onClick={e => edit ? handleUpdate() : handleSubmit()}
                                            size='large' style={{ background: edit ? `#f09a45` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }} block
                                        >{edit ? '修改' : '送出'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            />
        </>
    )
}
export default AdminFolderModal;
